/* Kickdopa email-capture popup — self-bootstrap version (~6KB). Replaces Privy. */
(function () {
  'use strict';

  /* Hard-coded config (mirrors the snippet defaults; edit here to change) */
  var CFG = {
    delay: 12,
    scrollDepth: 35,
    countdown: 25,
    cooldownDays: 30,
    discount: 'WELCOME10',
    mainTitle: "You've Got A",
    mainStrong: 'Mystery Discount',
    quizSubtitle: 'What can we help you with?',
    q1: 'Energy without the crash',
    q2: 'Nicotine-free oral energy',
    q3: 'Sharper focus & clarity',
    q4: 'Just exploring',
    emailSub: 'Drop your email to claim it.',
    successTitle: "You're In",
    successSub: 'Use this code at checkout:',
    successBtn: 'Shop now',
    successLink: '/products/energy-pouches'
  };

  function buildPopupHTML() {
    var canBase = 'https://cdn.shopify.com/s/files/1/0814/1730/6345/files/Kickdopa_';
    function esc(s){return String(s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
    return '' +
'<div class="kd-popup" id="kd-popup" data-discount="'+esc(CFG.discount)+
'" data-countdown="'+CFG.countdown+'" data-delay="'+CFG.delay+
'" data-scroll-depth="'+CFG.scrollDepth+'" data-cooldown-days="'+CFG.cooldownDays+'" aria-hidden="true" hidden>'+
  '<div class="kd-popup__overlay"></div>'+
  '<div class="kd-popup__cans" aria-hidden="true">'+
    '<img class="kd-popup__can kd-popup__can--1" src="'+canBase+'Mint_cutout_v2.png?width=600" alt="" loading="lazy" decoding="async">'+
    '<img class="kd-popup__can kd-popup__can--2" src="'+canBase+'Coffee_cutout_v2.png?width=600" alt="" loading="lazy" decoding="async">'+
    '<img class="kd-popup__can kd-popup__can--3" src="'+canBase+'Energy_cutout_v2.png?width=600" alt="" loading="lazy" decoding="async">'+
    '<img class="kd-popup__can kd-popup__can--4" src="'+canBase+'Watermelon_cutout_v2.png?width=600" alt="" loading="lazy" decoding="async">'+
    '<img class="kd-popup__can kd-popup__can--5" src="'+canBase+'Lemon_cutout_v2.png?width=600" alt="" loading="lazy" decoding="async">'+
  '</div>'+
  '<button class="kd-popup__close" type="button" aria-label="Close" data-kd-action="close">'+
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>'+
  '</button>'+
  '<div class="kd-popup__inner">'+
    '<div class="kd-popup__brand">KICKDOPA</div>'+
    '<div class="kd-popup__step kd-popup__step--quiz" data-step="quiz">'+
      '<div class="kd-popup__timer" id="kd-popup-timer" aria-live="polite">0:'+CFG.countdown+'</div>'+
      '<h2 class="kd-popup__title">'+esc(CFG.mainTitle)+'<br><strong>'+esc(CFG.mainStrong)+'</strong></h2>'+
      '<p class="kd-popup__subtitle">'+esc(CFG.quizSubtitle)+'</p>'+
      '<div class="kd-popup__buttons">'+
        '<button class="kd-popup__btn" type="button" data-kd-action="select" data-quiz="energy">'+esc(CFG.q1)+'</button>'+
        '<button class="kd-popup__btn" type="button" data-kd-action="select" data-quiz="clean-energy">'+esc(CFG.q2)+'</button>'+
        '<button class="kd-popup__btn" type="button" data-kd-action="select" data-quiz="focus">'+esc(CFG.q3)+'</button>'+
        '<button class="kd-popup__btn" type="button" data-kd-action="select" data-quiz="exploring">'+esc(CFG.q4)+'</button>'+
      '</div>'+
    '</div>'+
    '<div class="kd-popup__step kd-popup__step--email" data-step="email" hidden>'+
      '<h2 class="kd-popup__title">'+esc(CFG.mainTitle)+'<br><strong>'+esc(CFG.mainStrong)+'</strong></h2>'+
      '<p class="kd-popup__subtitle">'+esc(CFG.emailSub)+'</p>'+
      '<form class="kd-popup__form" id="kd-popup-form" novalidate>'+
        '<input type="email" required autocomplete="email" placeholder="Your email address" name="email" id="kd-popup-email" aria-label="Email address">'+
        '<button type="submit" class="kd-popup__btn kd-popup__btn--primary" id="kd-popup-submit">CONTINUE</button>'+
      '</form>'+
      '<div class="kd-popup__error" id="kd-popup-error" role="alert" hidden></div>'+
      '<p class="kd-popup__legal">By submitting, you agree to receive marketing emails from Kickdopa. Unsubscribe anytime.</p>'+
    '</div>'+
    '<div class="kd-popup__step kd-popup__step--success" data-step="success" hidden>'+
      '<div class="kd-popup__check" aria-hidden="true">'+
        '<svg width="64" height="64" viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="32" cy="32" r="28"/><path d="M20 33l8 8 16-18"/></svg>'+
      '</div>'+
      '<h2 class="kd-popup__title"><strong>'+esc(CFG.successTitle)+'</strong></h2>'+
      '<p class="kd-popup__subtitle">'+esc(CFG.successSub)+'</p>'+
      '<div class="kd-popup__code" id="kd-popup-code">'+esc(CFG.discount)+'</div>'+
      '<a class="kd-popup__btn kd-popup__btn--primary" href="'+esc(CFG.successLink)+'" data-kd-action="shop">'+esc(CFG.successBtn)+'</a>'+
      '<button class="kd-popup__copy" type="button" data-kd-action="copy" data-code="'+esc(CFG.discount)+'">Copy code</button>'+
    '</div>'+
  '</div>'+
'</div>';
  }

  /* Inject popup DOM into <body> if not already present */
  function ensureDOM() {
    if (document.getElementById('kd-popup')) return;
    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildPopupHTML();
    document.body.appendChild(wrapper.firstChild);
  }

  var STORAGE_KEY = 'kd_popup_v1';
  var SHOWN_KEY   = 'kd_popup_shown_session';

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function normalizePath(path) {
    var clean = (path || '/').split('?')[0].split('#')[0].replace(/\/+$/, '');
    return clean || '/';
  }

  function isPopupEligiblePage() {
    if (isDesignMode()) return true;
    var path = normalizePath(window.location.pathname);
    return path === '/products/energy-pouches' ||
      path === '/products/kickdopa-caffeine-nootropic-energy-pouches';
  }

  function getState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  }
  function saveState(patch) {
    var s = getState();
    Object.keys(patch).forEach(function (k) { s[k] = patch[k]; });
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function shouldShow(popup) {
    /* Never auto-show inside Shopify Customizer (designMode) — user enables via toggle */
    if (isDesignMode()) return false;
    if (!isPopupEligiblePage()) return false;
    if (sessionStorage.getItem(SHOWN_KEY)) return false;

    var s = getState();
    if (s.completed) return false;

    var cooldownDays = parseInt(popup.dataset.cooldownDays, 10) || 30;
    var cooldownMs = cooldownDays * 86400000;
    if (s.dismissedAt && Date.now() - s.dismissedAt < cooldownMs) return false;

    return true;
  }

  function getScrollProgress() {
    var doc = document.documentElement;
    var body = document.body;
    var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
    var scrollHeight = Math.max(
      body.scrollHeight || 0,
      doc.scrollHeight || 0,
      body.offsetHeight || 0,
      doc.offsetHeight || 0
    );
    var viewport = window.innerHeight || doc.clientHeight || 0;
    var maxScroll = scrollHeight - viewport;
    if (maxScroll <= 0) return 0;
    return Math.max(0, Math.min(100, (scrollTop / maxScroll) * 100));
  }

  function scheduleAutoOpen(popup) {
    if (popup._kdAutoOpenCleanup) popup._kdAutoOpenCleanup();

    var opened = false;
    var delayTimer = null;
    var scrollCheckTimer = null;
    var scrollDepth = parseInt(popup.dataset.scrollDepth, 10);
    if (!scrollDepth && scrollDepth !== 0) scrollDepth = CFG.scrollDepth;

    function cleanup() {
      if (delayTimer) clearTimeout(delayTimer);
      if (scrollCheckTimer) clearTimeout(scrollCheckTimer);
      window.removeEventListener('scroll', onScroll);
      popup._kdAutoOpenCleanup = null;
    }

    function trigger() {
      if (opened) return;
      if (!shouldShow(popup)) {
        cleanup();
        return;
      }
      opened = true;
      cleanup();
      open(popup);
    }

    function onScroll() {
      if (getScrollProgress() >= scrollDepth) trigger();
    }

    var delay = (parseInt(popup.dataset.delay, 10) || 0) * 1000;
    delayTimer = setTimeout(trigger, delay);

    if (scrollDepth > 0) {
      window.addEventListener('scroll', onScroll, { passive: true });
      scrollCheckTimer = setTimeout(onScroll, 300);
    }

    popup._kdAutoOpenCleanup = cleanup;
  }

  function init() {
    if (!isPopupEligiblePage()) return;
    ensureDOM();
    var popup = document.getElementById('kd-popup');
    if (!popup) return;

    /* Pre-bind handlers BEFORE deciding to show. In Shopify designMode the user
       might preview by clicking the section — handlers should still work. */
    popup.addEventListener('click', onClick);
    var form = document.getElementById('kd-popup-form');
    if (form) form.addEventListener('submit', onSubmit);

    if (!shouldShow(popup)) return;

    scheduleAutoOpen(popup);
  }

  var countdownInterval = null;

  function open(popup) {
    sessionStorage.setItem(SHOWN_KEY, '1');
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('kd-popup-open');
    document.body.classList.add('kd-popup-open');

    var first = popup.querySelector('.kd-popup__btn');
    if (first) {
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }

    /* Start countdown on quiz step */
    var timerEl = document.getElementById('kd-popup-timer');
    var remaining = parseInt(popup.dataset.countdown, 10) || 25;
    function tick() {
      if (timerEl) {
        var m = Math.floor(remaining / 60);
        var s = remaining % 60;
        timerEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      }
      if (remaining <= 0) {
        clearInterval(countdownInterval);
        countdownInterval = null;
        dismiss(popup);  /* timeout = silent close */
        return;
      }
      remaining--;
    }
    tick();
    countdownInterval = setInterval(tick, 1000);

    /* Esc to close */
    document.addEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      var popup = document.getElementById('kd-popup');
      if (popup && !popup.hidden) dismiss(popup);
    }
  }

  function showStep(popup, name) {
    /* On any step change past quiz, kill countdown */
    if (name !== 'quiz' && countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
    var steps = popup.querySelectorAll('[data-step]');
    for (var i = 0; i < steps.length; i++) {
      steps[i].hidden = steps[i].dataset.step !== name;
    }
    if (name === 'email') {
      setTimeout(function () {
        var input = document.getElementById('kd-popup-email');
        if (input) input.focus();
      }, 100);
    }
  }

  function onClick(e) {
    var popup = document.getElementById('kd-popup');
    var t = e.target.closest && e.target.closest('[data-kd-action]');
    if (!t) return;
    var act = t.dataset.kdAction;
    if (act === 'close') {
      dismiss(popup);
    } else if (act === 'select') {
      popup._quiz = t.dataset.quiz || 'general';
      showStep(popup, 'email');
    } else if (act === 'shop') {
      /* Native <a href> handles navigation; close + lock release */
      finalize(popup);
    } else if (act === 'copy') {
      copyCode(t);
    }
  }

  function copyCode(btn) {
    var code = btn.dataset.code || '';
    if (!code) return;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(flashCopied.bind(null, btn));
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); flashCopied(btn); }
      catch (e) {}
      document.body.removeChild(ta);
    }
  }
  function flashCopied(btn) {
    btn.classList.add('is-copied');
    var orig = btn.textContent;
    btn.textContent = 'Copied';
    setTimeout(function () {
      btn.classList.remove('is-copied');
      btn.textContent = orig;
    }, 2000);
  }

  function onSubmit(e) {
    e.preventDefault();
    var popup = document.getElementById('kd-popup');
    var input = document.getElementById('kd-popup-email');
    var errEl = document.getElementById('kd-popup-error');
    var btn = document.getElementById('kd-popup-submit');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

    var email = (input.value || '').trim();
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      if (errEl) { errEl.hidden = false; errEl.textContent = 'Please enter a valid email.'; }
      return;
    }

    if (btn) {
      btn.disabled = true;
      btn._origText = btn.textContent;
      btn.textContent = 'Submitting…';
    }

    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[accepts_marketing]', 'true');
    fd.append('contact[tags]', 'newsletter,popup,interest:' + (popup._quiz || 'general'));

    fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(handleSubmit)
      .catch(handleSubmit);

    function handleSubmit() {
      saveState({ completed: true, completedAt: Date.now(), email: email, quiz: popup._quiz || null });
      if (btn) {
        btn.disabled = false;
        if (btn._origText) btn.textContent = btn._origText;
      }
      showStep(popup, 'success');
    }
  }

  function dismiss(popup) {
    saveState({ dismissedAt: Date.now() });
    finalize(popup);
  }

  function finalize(popup) {
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
    document.removeEventListener('keydown', onKey);
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('kd-popup-open');
    document.body.classList.remove('kd-popup-open');
  }

  /* === Public API: manual open (bypasses cooldown / completion checks) === */
  window.kdOpenPopup = function () {
    if (!isPopupEligiblePage()) return;
    ensureDOM();
    var popup = document.getElementById('kd-popup');
    if (!popup) return;
    /* If user already submitted: jump to success step so they can re-copy the code */
    var s = getState();
    showStep(popup, s.completed ? 'success' : 'quiz');
    if (popup.hidden) {
      open(popup);
    }
  };

  /* === Inject "Get 10% off" link with auto-demo hover + ripple cycle ===
     Variant 11: every 4 seconds, simulates hover-then-click visually so users
     learn this is interactive. Pauses if user is hovering. Stops on real click. */
  function injectPromoLink() {
    if (!isPopupEligiblePage()) return;
    var content = document.querySelector('.m-announcement-bar__content');
    if (!content) return;
    if (content.querySelector('.kd-promo-link')) return;

    var demoInterval = null;

    var sep = document.createElement('span');
    sep.className = 'kd-promo-sep';
    sep.textContent = '·';

    var link = document.createElement('a');
    link.className = 'kd-promo-link';
    link.href = '#kd-popup';
    link.setAttribute('aria-label', 'Get 10 percent off your first order');
    link.innerHTML = 'Get <span class="kd-promo-em">10% off</span> <span class="kd-promo-arrow">→</span>';

    function activate(e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      /* Stop the auto-demo cycle once user interacts */
      if (demoInterval) { clearInterval(demoInterval); demoInterval = null; }
      link.classList.remove('kd-promo-demo-hover');
      link.classList.remove('kd-promo-demo-click');
      window.kdOpenPopup();
      return false;
    }
    /* Capture phase fires before any bubble-phase listener attached by Minimog */
    link.addEventListener('click', activate, true);
    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') activate(e);
    });
    /* Pause auto-demo while user genuinely hovers */
    link.addEventListener('mouseenter', function () {
      link.classList.remove('kd-promo-demo-hover');
      link.classList.remove('kd-promo-demo-click');
    });

    content.appendChild(sep);
    content.appendChild(link);

    /* Auto-demo loop — every 4s show "hover then click" so user learns it's clickable */
    function runDemo() {
      if (!link.isConnected) { if (demoInterval) clearInterval(demoInterval); return; }
      if (link.matches(':hover')) return;
      link.classList.add('kd-promo-demo-hover');
      setTimeout(function () {
        if (link.isConnected && demoInterval) link.classList.add('kd-promo-demo-click');
      }, 600);
      setTimeout(function () {
        if (link.isConnected) {
          link.classList.remove('kd-promo-demo-hover');
          link.classList.remove('kd-promo-demo-click');
        }
      }, 1400);
    }
    /* First demo after 2 seconds (give page a beat to settle), then every 4s */
    setTimeout(function () {
      runDemo();
      demoInterval = setInterval(runDemo, 4000);
    }, 2000);
  }

  function tryInjectPromoLink() {
    if (!isPopupEligiblePage()) return;
    injectPromoLink();
    /* Re-try in case the announcement bar mounts asynchronously */
    setTimeout(injectPromoLink, 300);
    setTimeout(injectPromoLink, 1500);
    setTimeout(injectPromoLink, 4000);
  }

  /* Boot */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      tryInjectPromoLink();
    });
  } else {
    init();
    tryInjectPromoLink();
  }

  /* Shopify Customizer support: re-init on section load/select for live preview */
  document.addEventListener('shopify:section:load', function () {
    init();
    injectPromoLink();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.detail && e.detail.sectionId && document.getElementById('kd-popup')) {
      var popup = document.getElementById('kd-popup');
      if (popup.hidden) open(popup);
    }
  });
})();
